<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Αναζήτηση"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols=2>
              <v-select
                v-model="unit"
                :items="['Σετ', 'Τεμάχιο', 'Λίτρα', 'Κιλά', 'Εργασία']"
                label="Μονάδα Μέτρησης"
                prepend-icon="mdi-scale"
                clearable
              ></v-select>
            </v-col>
              <v-col cols=3>
                 <v-file-input
                  chips
                  prepend-icon="mdi-microsoft-excel"
                  accept=".xls"
                  label="Ανταλλακτικών"
                  placeholder="Επιλέξτε αρχείο ανταλλακτικών"
                  v-model="partsFile"
                ></v-file-input>
              </v-col>
              <v-col>
                <v-btn @click="updateParts" icon><v-icon>mdi-update</v-icon></v-btn>
              </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Λίστα Ανταλλακτικών</h1>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="parts"
      :search="search"
      loading: false
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      loading-text="Loading... Please wait"
    >
     <template v-slot:item.actions>
        <v-btn
          icon
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>

    <template v-slot:item.RetailPrice="{ item }">
       {{ tocurr(item.RetailPrice) }}
    </template>
    <template v-slot:item.BulkPrice="{ item }">
       {{ tocurr(item.BulkPrice) }}
    </template>
     <template v-slot:item.Frequency="{ item }">
       {{ item.RelatedLines.length }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
       <tr>
      <td :colspan="headers.length">
        More info about {{ item.itemcode }}
        <p>Related invoices:</p>
      </td>
      </tr>
      <v-list-item v-for='i in item.RelatedLines' :key=i.Id>
            <v-list-item-content>
             <v-list-item-title> {{ i.InvoiceId }}
               <v-btn
                    icon
                    :to="'/invoice/details/'+i.InvoiceId"
                  >
                  <v-icon>mdi-git</v-icon>
                  </v-btn>
             </v-list-item-title>
            </v-list-item-content>
            </v-list-item>

    </template>
    </v-data-table>
  </v-card>
</template>
  </v-container>
</template>

<script>

//import QuoteCard from '../../components/QuoteCard.vue';

export default {
  components: {
 //   QuoteCard
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
  },
  data() {
    return {
      menu: false,
      expanded: [],
      dialog: false,
      loading: true,
      customer: '',
      vehicle: [],
      search: '',
      parts: [],
      unit: null,
      partsFile: null,
      headers: [
          {
            text: 'Κωδικός',
            align: 'start',
            //sortable: false,
            value: 'ItemCode',
            width: '15%',
          },
          { text: 'Περιγραφή', value: 'Desc', width: '40%'},
          { text: 'Μονάδα Μέτρησης', value: 'Unit', width: '10%',
          filter: (value) => {
            if (!this.unit) return true;
            return value == this.unit;
            },

          },
          { text: 'Τιμή λιανικής', value: 'RetailPrice', align: 'end', groupable: false },
          { text: 'Τιμή χονδρικής', value: 'BulkPrice', align: 'end', groupable: false },
          { text: 'Συχνότητα', value: 'Frequency', align: 'end', groupable: false },
          { text: 'Actions', value: 'actions', groupable: false },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/invoices/parts');
        // console.log(response);
        this.parts = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },

  async updateParts() {
    if (this.partsFile) {
      try {
        var formData = new FormData();
        formData.append("parts_file", this.partsFile);
        let resp = await this.$api.post("/invoices/parts/update", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if (resp.status == 201) {
          alert("Τα ανταλλακτικά ενημερώθηκαν", resp.data.added);
        } else {
          alert("Σφάλμα ενημέρωσης");
          console.log(resp);
        }
        this.partsFile = null;
        const response = await this.$api.get('/invoices/parts');
        this.parts = response.data;
      } catch (error) {
        console.log(error);
      }
    }
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },
  }
}
</script>
